import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { Vehicle } from './vehicle/vehicle.component'
import ImageTruck1tMini from './assets/in/truck_1t_mini.svg'
import ImageTruck2tMini from './assets/in/truck_2t_mini.svg'
import ImageTruck3tLight from './assets/in/truck_3t_light.svg'
import ImageTruck4t from './assets/in/truck_4t.svg'
import ImageTruck6t from './assets/in/truck_6t.svg'
import ImageTruck8t from './assets/in/truck_8t.svg'

const VehicleListIN = ({ estimations, quoteInProgress }) => {
  const [t] = useTranslation()
  
  const truck1tMiniFree = estimations.ton1 || t('text__body__minimum_fee__truck_1t_mini')
  const truck2tMiniFree = estimations.ton2 || t('text__body__minimum_fee__truck_2t_mini')
  const truck3tLightFree = estimations.ton3 || t('text__body__minimum_fee__truck_3t_light')
  const truck4tFree = estimations.ton4 || t('text__body__minimum_fee__truck_4t')
  const truck6tFree = estimations.ton6 || t('text__body__minimum_fee__truck_6t')
  const truck8tFree = estimations.ton8 || t('text__body__minimum_fee__truck_8t')

  const defaultFee = Object.keys(estimations).length === 0

  return (
    <>
      <Vehicle
        image={ImageTruck1tMini}
        name={t('common__vehicle__truck_1t_mini')}
        description={t('text__body__vehicle_description__truck_1t_mini')}
        fee={truck1tMiniFree}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageTruck2tMini}
        name={t('common__vehicle__truck_2t_mini')}
        description={t('text__body__vehicle_description__truck_2t_mini')}
        fee={truck2tMiniFree}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageTruck3tLight}
        name={t('common__vehicle__truck_3t_light')}
        description={t('text__body__vehicle_description__truck_3t_light')}
        fee={truck3tLightFree}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageTruck4t}
        name={t('common__vehicle__truck_4t')}
        description={t('text__body__vehicle_description__truck_4t')}
        fee={truck4tFree}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageTruck6t}
        name={t('common__vehicle__truck_6t')}
        description={t('text__body__vehicle_description__truck_6t')}
        fee={truck6tFree}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageTruck8t}
        name={t('common__vehicle__truck_8t')}
        description={t('text__body__vehicle_description__truck_8t')}
        fee={truck8tFree}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
    </>
  )
}

VehicleListIN.propTypes = {
  estimations: PropTypes.object,
  quoteInProgress: PropTypes.bool,
}

export { VehicleListIN }
